// extracted by mini-css-extract-plugin
export var filterCategory = "SimpleBlogLatestSectionFiltersMobile-module--filterCategory--37d84";
export var filterSelector = "SimpleBlogLatestSectionFiltersMobile-module--filterSelector--98d98";
export var filterSelectorSubCategory = "SimpleBlogLatestSectionFiltersMobile-module--filterSelectorSubCategory--82c4f";
export var filters = "SimpleBlogLatestSectionFiltersMobile-module--filters--9317d";
export var filtersGrid = "SimpleBlogLatestSectionFiltersMobile-module--filtersGrid--3bee8";
export var filtersGrid2 = "SimpleBlogLatestSectionFiltersMobile-module--filtersGrid2--77c95";